import React from "react";
import "./App.css";

import Container from "react-bootstrap/Container";
import Navbar from "react-bootstrap/Navbar";
import Nav from "react-bootstrap/Nav";
import NavItem from "react-bootstrap/NavItem";
import HomePage from "./pages/Homepage";
import ContactPage from "./pages/Contact";
import AboutPage from "./pages/About";
import ProjectPage from "./pages/ProjectPage/ProjectPage";
import Architecture from "./components/Architecture/Architecture"
import ReactGA from "react-ga";

import data from "./Projects Data/data.json";

import CV from "./pages/CV/CV";

import { BrowserRouter as Router, Route, Link } from "react-router-dom";

class App extends React.Component {
  constructor(props) {
    super(props);
    this.onSelect.bind(this);
    // this.toggleNav.bind(this);
    this.state = {
      title: "",
      headerLinks: [
        { title: "Home", path: "/" },
        // { title: "About", path: "/about" },
        { title: "Contact", path: "/contact" },
      ],
      home: {
        title: "Hi",
        subtitle:
          "I’m Miltos, an architect working with interactive technology, software and electronics",
        content: "Checkout out my projects below",
      },
      about: {
        title: "information about me",
      },
      contact: {
        title: "ways to find me",
      },
      navExpanded: false,
    };
    this.myRef = React.createRef();
  }

  onSelect(e) {
    console.log("OnSelect");
    // console.log(this.state.navExpanded);
    // this.setState({navExpanded: false});
  }
  componentDidMount() {
    ReactGA.initialize("UA-177611834-1");
    document.title = "Miltos Tsakiris";
    ReactGA.pageview(window.location.pathname + window.location.search);
  }
  getInitialState() {
    return {
      navExpanded: false,
    };
  }

  setNavExpanded(expanded) {
    console.log("clicking menu");
    this.setState({ navExpanded: expanded });
  }

  closeNav() {
    console.log("CLose Nav Selected");
    this.setState({ navExpanded: false });
  }
  render() {
    return (
      <div ref={this.myRef}>
        <Router>
          <Container className="p-0" fluid={true}>
            <Navbar
              // onToogle={() => this.setNavExpanded}
              key={this.state.navExpanded}
              expanded={this.state.navExpanded}
              color="faded"
              bg="transparent"
              expand="xl"
              style={{ zIndex: 1 }}
            >
              <Navbar.Brand></Navbar.Brand>
            <Navbar.Toggle onClick={() => this.setNavExpanded()} />
            <Navbar.Collapse id="navbar-toogle">
              <Nav>
                <NavItem>
                  <Link
                    onClick={() => this.closeNav()}
                    className="nav-link"
                    to="/"
                  >
                    Home
                    </Link>
                </NavItem>

                {/* <Link onClick={() => this.closeNav()} className="nav-link" to="/about">
                    About
                  </Link> */}
                <Link
                  onClick={() => this.closeNav()}
                  className="nav-link"
                  to="/contact"
                >
                  Contact
                  </Link>
              </Nav>
            </Navbar.Collapse>
            </Navbar>
          {data.map((dato) => {
            return (
              <Route
                path={`/${dato.headerText.title}`}
                key={`/${dato.headerText.title}`}
                exact
                render={(id) => (
                  <div className="route-page">
                    <ProjectPage
                      key={ dato.headerText}
                      headerText={dato.headerText}
                      imgSrc={dato.imgSrc}
                      videoSrc={dato.videoSrc}
                      chapters={dato.chapters}
                      videos={dato.videos}
                      videoHeader={dato.videoHeader}
                      imgZoom={dato.imgZoom}
                      glitch={dato.glitch}
                    />
                  </div>
                )}
              />
            );
          })}

          <Route
            path="/"
            exact
            render={() => (
              <HomePage
                title={this.state.home.title}
                subtitle={this.state.home.subtitle}
                content={this.state.home.content}
              />
            )}
          />
          <Route
            path="/about"
            exact
            render={() => (
              <AboutPage
                title={this.state.about.title}
                subtitle={this.state.about.subtitle}
              />
            )}
          />
          <Route
            path="/contact"
            exact
            render={() => (
              <ContactPage
                title={this.state.contact.title}
                subtitle={this.state.contact.subtitle}
              />
            )}
          />
          <Route path="/CV" exact render={() => <CV />} />
          <Route path="/architecture" exact render={() => <Architecture />} />

          {/* <Footer /> */}
          </Container>
        </Router>
      </div >
    );
  }
}

export default App;
